import { Component, HostBinding, Input } from '@angular/core';
import { ButtonComponent } from '../core/button.component';

@Component({
  selector: 'spb-gradient-button',
  templateUrl: './gradient-button.component.html',
})
export class GradientButtonComponent extends ButtonComponent {
  @HostBinding('class.spb-gradient-button') hostBaseClass = true;
  @Input() gradientImage = {
    normal: '',
    hover: '',
  };
  @Input() borderColor = '';
}
